import React, { useState, useEffect, useRef } from 'react';

function SearchInput({ value, onChange, placeholder = 'Buscar...', style, className }) {
  const [internal, setInternal] = useState(value || '');
  const timer = useRef(null);

  useEffect(() => { setInternal(value || ''); }, [value]);

  function handleChange(e) {
    const v = e.target.value;
    setInternal(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onChange(v), 400);
  }

  function handleClear() {
    setInternal('');
    clearTimeout(timer.current);
    onChange('');
  }

  return (
    <div className={`search-input${className ? ' ' + className : ''}`} style={style}>
      <span className="search-input__icon">🔍</span>
      <input
        type="text"
        className="search-input__field"
        value={internal}
        onChange={handleChange}
        placeholder={placeholder}
      />
      {internal && (
        <button className="search-input__clear" onClick={handleClear}>✕</button>
      )}
    </div>
  );
}

export default SearchInput;
